var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5195 75.8652H147.758V146.309H35.5195V75.8652Z",
    fill: "#85C3F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.403 41.5568L83.2414 40.9278C67.662 40.6953 55.4181 54.1938 57.1642 69.6768L59.7019 92.1784L93.7418 117.489L125.403 93.7826V41.5568Z",
    fill: "#BFE1FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1987 40.3584C61.9705 40.3584 54.4895 47.8585 54.4895 57.1104V72.3688H35.5196C33.8508 72.3688 32.498 73.725 32.498 75.398V77.3592C32.498 77.3597 32.498 77.3602 32.498 77.3608V146.308C32.498 147.981 33.8508 149.337 35.5196 149.337H145.477C147.146 149.337 148.498 147.981 148.498 146.308V77.406C148.499 77.3753 148.499 77.3446 148.498 77.3139V75.398C148.498 73.725 147.146 72.3688 145.477 72.3688H126.507V43.3877C126.507 41.7146 125.154 40.3584 123.485 40.3584H71.1987ZM138.986 78.4273H126.507V87.7328L138.986 78.4273ZM124.763 96.584C125.136 96.4093 125.467 96.1604 125.739 95.8563L142.455 83.3908V143.279H38.5411V83.3906L88.6952 120.79C89.7656 121.588 91.2313 121.588 92.3017 120.79L124.763 96.584ZM120.464 92.2389V46.4169H71.1987C65.3079 46.4169 60.5325 51.2045 60.5325 57.1104V92.2387L90.4984 114.584L120.464 92.2389ZM54.4895 87.7325V78.4273H42.0107L54.4895 87.7325Z",
    fill: "#0C88ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.586 85.9296C93.2398 85.9296 96.2017 82.9601 96.2017 79.2969C96.2017 75.6338 93.2398 72.6643 89.586 72.6643C85.9323 72.6643 82.9704 75.6338 82.9704 79.2969C82.9704 82.9601 85.9323 85.9296 89.586 85.9296ZM89.586 89.589C95.2557 89.589 99.8518 84.9811 99.8518 79.2969C99.8518 73.6128 95.2557 69.0049 89.586 69.0049C83.9164 69.0049 79.3203 73.6128 79.3203 79.2969C79.3203 84.9811 83.9164 89.589 89.586 89.589Z",
    fill: "#85C3F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.832 66.1642C105.638 66.9731 105.638 68.2844 104.832 69.0933L90.4576 83.5041C89.6508 84.3129 88.3428 84.3129 87.5361 83.5041L82.8795 78.8356C82.0727 78.0267 82.0727 76.7154 82.8795 75.9066C83.6862 75.0977 84.9942 75.0977 85.801 75.9065L88.9968 79.1105L101.91 66.1642C102.717 65.3554 104.025 65.3554 104.832 66.1642Z",
    fill: "#0C88ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2837 36.8083C59.1087 36.8083 50.8601 45.0779 50.8601 55.2791V58.3072H44.8193V55.2791C44.8193 41.7331 55.7724 30.752 69.2837 30.752H72.3041V36.8083H69.2837Z",
    fill: "#0C88ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailImage);
export default __webpack_public_path__ + "static/media/email-image.7d829605927e58e3b6d81b828cfe7cf7.svg";
export { ForwardRef as ReactComponent };